import type { ReactNode } from "react";
import { Checkbox } from "@/components/ui/checkbox";

interface BulkActionBarProps {
  selectAllLabel: string;
  allSelected: boolean;
  onSelectAllChange: (checked: boolean) => void;
  selectionContent?: ReactNode;
  actions?: ReactNode;
}

export function BulkActionBar({
  selectAllLabel,
  allSelected,
  onSelectAllChange,
  selectionContent,
  actions,
}: BulkActionBarProps) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-lg border bg-muted/40 p-3">
      <div className="flex items-center gap-4">
        <label className="flex cursor-pointer items-center gap-2 text-sm">
          <Checkbox
            checked={allSelected}
            onCheckedChange={(checked) => onSelectAllChange(checked === true)}
            aria-label={selectAllLabel}
          />
          {selectAllLabel}
        </label>
        {selectionContent}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
